// ABOUTME: Sentry client-side initialisation for browser error reporting.
// ABOUTME: PII capture disabled; only sends events in production builds.
import * as Sentry from '@sentry/astro';

function isStudioUrl(url) {
  if (!url) return false;
  try {
    return new URL(url, window.location.origin).pathname.startsWith('/studio');
  } catch {
    return false;
  }
}

Sentry.init({
  dsn: 'https://77547dbcdfdff6a9e55b32b40b43b3ac@o4511234504196096.ingest.de.sentry.io/4511234542600272',
  sendDefaultPii: false,
  environment: import.meta.env.PUBLIC_DEPLOY_ENV,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 1.0,
  // Injected by Microsoft Outlook SafeLinks link scanning, not our code.
  ignoreErrors: ['Object Not Found Matching Id'],
  beforeSend(event) {
    if (isStudioUrl(event.request?.url) || isStudioUrl(window.location.href)) {
      return null;
    }
    return event;
  },
});
